import React, {Component, Suspense, lazy} from 'react';
import { Routes, Route } from 'react-router-dom';
import {ThemeProvider } from '@mui/material/styles';
import ThemeCustomization from './components/Theme/Theme';
import SidebarPanel from './components/SidebarPanel/SidebarPanel';
import Header from './components/Header/Header';
import SvgIcons from "./components/Icons/SvgIcons";
import './styles/sass/style.scss';

const hasTouch = require('detect-touch').hasTouch;
const Home = lazy(() => import("./pages/Home"));
const AppDataDetails = lazy(() => import("./pages/AppDataDetails"));
const PageNotFound = lazy(() => import("./pages/PageNotFound"));
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_SKIP_TLS_VERIFY === 'true') {
    process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";
}

export default class App extends Component {

    theme: any;

    constructor(props: any) {
        super(props);
        this.theme = ThemeCustomization();
    }

    componentDidMount() {
        let className = hasTouch ? 'touch' : 'no-touch';

        document.querySelector('html')?.classList.add(className);
    }

    render() {
        return (
            <ThemeProvider theme={this.theme}>
                <Suspense fallback={<span className="loader loader--large"></span>}>
                    <Header />

                    <main className="main container">
                        <SidebarPanel />

                        <div className="content">
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/dashboard/database/:id" element={<AppDataDetails />} />
                                <Route path="*" element={<PageNotFound />} />
                            </Routes>
                        </div>
                    </main>

                    <SvgIcons />
                    <div className="overlay"></div>
                </Suspense>
            </ThemeProvider>
        );
    }
}
